import { Card, Drawer, Empty, Tag } from 'antd'
import { ClassMonthlySummary, MonthPlanResult } from '../types'
import { MonthOverviewPanel } from './MonthOverviewPanel'
import { ConfigDetailSections } from './ConfigDetailSections'

type MonthPlanDrawerProps = {
  open: boolean
  width: number | string
  loading: boolean
  summary: ClassMonthlySummary
  hasSelection: boolean
  defaultClassDurationMinutes: number
  monthPlan: MonthPlanResult | null
  onClose: () => void
}

export function MonthPlanDrawer({
  open,
  width,
  loading,
  summary,
  hasSelection,
  defaultClassDurationMinutes,
  monthPlan,
  onClose,
}: MonthPlanDrawerProps) {
  const monthlyInfoSections = monthPlan?.sections || []
  const formatMonthDay = (dateText: string) => dateText.slice(5)
  const formatRange = (startDate?: string | null, endDate?: string | null) => {
    if (!startDate || !endDate) {
      return '暂无'
    }

    return `${formatMonthDay(startDate)} - ${formatMonthDay(endDate)}`
  }

  return (
    <Drawer
      title="月配置"
      open={open}
      onClose={onClose}
      width={width}
      destroyOnHidden
    >
      <MonthOverviewPanel
        loading={loading}
        hasSelection={hasSelection}
        summary={summary}
        defaultClassDurationMinutes={defaultClassDurationMinutes}
        showMonthPlanButton={false}
      />

      <Card
        size="small"
        className="mt-4"
        title="月计划"
        loading={loading}
        extra={
          monthlyInfoSections.length > 0 ? (
            <span className="text-xs text-slate-500">
              共 {monthlyInfoSections.length} 段配置
            </span>
          ) : null
        }
      >
        {monthlyInfoSections.length > 0 ? (
          <div className="flex flex-col gap-3">
            {monthlyInfoSections.map((section, index) => {
              return (
                <section
                  key={section.id}
                  className="rounded-2xl border border-slate-200 bg-slate-50/80 p-4"
                >
                  <div className="border-b border-slate-200 pb-3">
                    <div className="flex flex-col gap-2">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="text-sm font-semibold text-slate-900">
                          月计划 {index + 1}
                        </span>
                        {section.isAllDayPricing ? <Tag color="gold">全天班计费</Tag> : null}
                        <Tag color="blue">个训 {section.stats.training} 节</Tag>
                        <Tag color="cyan">集体 {section.stats.group} 节</Tag>
                      </div>
                      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-slate-500">
                        <span>计划 {formatRange(section.generatedStartDate, section.generatedEndDate)}</span>
                        <span>实际 {formatRange(section.actualStartDate, section.actualEndDate)}</span>
                      </div>
                    </div>
                  </div>
                  <div className="mt-4">
                    <ConfigDetailSections
                      weekdays={section.weekdays}
                      isAllDayPricing={section.isAllDayPricing}
                      monthlyPrice={section.monthlyPrice}
                      templates={section.templates}
                    />
                  </div>
                </section>
              )
            })}
          </div>
        ) : (
          <Empty description="当前月份暂无月配置" />
        )}
      </Card>
    </Drawer>
  )
}
